import { ISeoDataSchema } from '../../../repositories/countryside-search/entities/seo/SeoDataSchema';
import { INewobjectCategorySetForListPresenterSchema } from '../../../repositories/countryside-search/entities/newobject_category/NewobjectCategorySetForListPresenterSchema';
import { IVillageCounterSetSchema } from '../../../repositories/countryside-search/entities/counter/VillageCounterSetSchema';
import { ON_SALE_OBJECTS } from '../../../interfaces/villages';

export const generateObjectsLink = (
  newObjectKey: keyof INewobjectCategorySetForListPresenterSchema,
  seo?: ISeoDataSchema | null,
  counterSet?: IVillageCounterSetSchema | null,
) => {
  if (!counterSet) {
    return null;
  }

  const onSale = (counterSet[ON_SALE_OBJECTS[newObjectKey]] as number) > 0;

  return onSale && seo ? (seo.url as string) : null;
};
